import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalProvider } from 'ui-product-approvals/components/ApprovalProvider';
import { ApprovalButton } from 'ui-product-approvals/components/button/ApprovalButton';
import { APP_GOVERNANCE_APPROVAL_ACTION, APP_GOVERNANCE_APPROVAL_TYPE } from './constants';
import { useGetLatestProductApprovalRequest } from './hooks/useGetLatestProductApprovalRequest';
import { useGetOrCreateApprovableObjectId } from './hooks/useGetOrCreateApprovableObjectId';
import { jsx as _jsx } from "react/jsx-runtime";
//DO NOT add DetailsPageContext usage on this component, this is designed to be used outside of the details page context.

export function AppGovernanceRequestButton({
  appId,
  appName
}) {
  const {
    approvableObjectId
  } = useGetOrCreateApprovableObjectId({
    appId
  });
  const {
    requestStatus
  } = useGetLatestProductApprovalRequest({
    approvableObjectId
  });
  if (requestStatus === 'APPROVAL_PENDING') {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.appGovernance.requestPending.tooltip"
      }),
      children: /*#__PURE__*/_jsx(Button, {
        disabled: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.appGovernance.requestPending.label"
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(ApprovalProvider, {
    approvableObjectId: approvableObjectId,
    assetName: appName,
    approvalType: APP_GOVERNANCE_APPROVAL_TYPE,
    approvalAction: APP_GOVERNANCE_APPROVAL_ACTION,
    restartOnConclude: true,
    children: /*#__PURE__*/_jsx(ApprovalButton, {
      "data-test-id": "product-approval-button"
    }, `product-approval-button-${approvableObjectId}`)
  });
}